export abstract class NodejsWorker {

  protected listeners: ((data: any) => any)[] = [];

  abstract messageEventListener(): (data: any) => any

  protected internalPostMessage(data: any) {
    if (this.isBrowser) {
      postMessage(data);
    } else {
      this.listeners.forEach((listener) => {
        listener({data});
      })
    }
  }

  addEventListener(event: 'message', handler: (data: any) => any) {
    this.listeners.push(handler)
  }

  postMessage(data: any) {
    if (typeof Worker !== 'undefined') {
      throw new Error('This should not happen')
    } else {
      Promise.resolve(this.messageEventListener()({data}));
    }
  }

  get isBrowser() {
    return typeof Worker !== 'undefined' || typeof postMessage !== 'undefined'
  }


}
